import Vue from 'vue'
import App from './App.vue'
import request from './api/request';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { initTongji } from './utils/seo.js';

Vue.config.productionTip = false
Vue.use(ElementUI);

// 全局兜底：组件渲染/生命周期出错时打印详细上下文，
// 避免"页面全白但控制台看不到原因"（生产构建会剥离 Vue 的警告信息）
Vue.config.errorHandler = function (err, vm, info) {
  console.error('[ceanx] 页面渲染出错：' + info, err, vm && vm.$options && vm.$options.name);
};
Vue.config.warnHandler = function (msg, vm, trace) {
  console.warn('[ceanx] ' + msg, trace);
};

// T-1：统一接口层（baseURL / 解包 / 错误映射 已内置）
Vue.prototype.$axios = request;
Vue.prototype.$baseUrl = request.defaults.baseURL;

// 百度统计（SEO_SITE.tongjiId 为空时不加载任何脚本）
initTongji();

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');